(function () {
    "use strict";

    angular
        .module('laekkerAI.tablet')
        .component('userInfo', {
            controller: 'TabletUserInfoController',
            templateUrl:  '/components/user-info/user-info.html',
            bindings: {
            }
        });
}());